<script lang="ts" setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const $props = defineProps({
  modelValue: {
    type: Boolean,
  },
});

const visible = ref(!$props.modelValue);

watch(
  () => $props.modelValue,
  (newVal: boolean) => {
    visible.value = !newVal;
  },
);
</script>

<template>
  <el-dialog
    v-model="visible"
    :show-close="false"
    width="512"
    modal-class="offline-dialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <template #header>
      <div class="content">
        <img src="/offline.png" alt="" class="icon" />
        <div>
          <div class="title">{{ t('internetDisconnected.title') }}</div>
          <div>
            {{ t('internetDisconnected.content') }}
          </div>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<style lang="sass" scoped>
.content
    display: flex
    align-items: top
    .title
        margin-bottom: 16px
.icon
    width:40px
    height:40px
    flex-shrink: 0
    margin-right: 16px
</style>

<style lang="sass">
.offline-dialog
    .el-dialog
        --el-dialog-border-radius: 8px
        &__header
            padding: 20px
        &__body
            display: none
</style>
